module.exports = __webpack_public_path__ + "static/media/panggung.7b7b27f5.png";